/**
 * tier-config.js
 *
 * Free  ($0):      Dashboard, Watchlist, Alerts Log, Settings
 * Basic ($9.99):   + Volume Spike · Telegram alerts: Triple Alignment, Double Alignment, Volume Spike
 * Pro   ($19.99):  + RBPullback, 20-50 Pullback · Telegram alerts: those strategies
 * Elite ($39.99):  + RSI-MTF, CCI Pullback, MTF 50 SMA, ProjectTD, Trend Pullback · all alerts
 */

/** Returns true if userTier meets or exceeds requiredTier */
export function hasAccess(userTier, requiredTier) {
  // Dev bypass: REACT_APP_DEV_UNLOCK=true in .env.local unlocks all strategies
  if (process.env.REACT_APP_DEV_UNLOCK === 'true') return true;
  const rank = { free: 0, basic: 1, pro: 2, elite: 3 };
  return (rank[userTier] ?? -1) >= (rank[requiredTier] ?? 99);
}

/** Route path -> minimum tier required */
export const ROUTE_TIERS = {
  '/dashboard':      'free',
  '/coin/:id':       'free',
  '/watchlist':      'free',
  '/alerts-log':     'free',
  '/settings':       'free',
  '/support':        'free',
  '/rubberband':     'pro',
  '/20-50-pullback': 'pro',
  '/rsi-mtf':        'elite',
  '/cci-pullback':   'elite',
  '/mtf-50sma':      'elite',
  '/topdog':         'elite',
  '/topdog-cci-combined': 'elite',
  '/trend-pullback': 'elite',
  '/volume-spike':   'basic',
  '/20ema-sr':       'elite',
  '/20-8ema-parabolic': 'elite',
  '/trend-breakout': 'elite',
  '/ttm-squeeze':    'elite',
  '/ttm-triple-squeeze': 'elite',
  '/ma-crossover':   'elite',
  '/kc-extreme':     'elite',
  '/combined':       'elite',
};

/** Strategy key -> minimum tier required for Telegram alerts */
export const ALERT_STRATEGY_TIERS = {
  'triple-alignment':    'basic',
  'double-alignment':    'basic',
  'rubberband':          'pro',
  '20-50-pullback':      'pro',
  'rsi-mtf':             'elite',
  'cci-pullback':        'elite',
  'mtf-50sma':           'elite',
  'topdog':              'elite',
  'topdog-cci-combined': 'elite',
  'trend-pullback':      'elite',
  'volume-spike':        'basic',
  '20ema-sr':            'elite',
  '20-8ema-parabolic':   'elite',
  'trend-breakout':      'elite',
  'ttm-squeeze':         'elite',
  'ma-crossover':        'elite',
  'kc-extreme':          'elite',
};

export const PLAN_INFO = {
  free: {
    name:     'Free',
    price:    0,
    label:    '$0 / mo',
    features: ['Live dashboard (top 150)', 'Watchlist', 'Alerts log', 'Coin detail with TradingView chart'],
  },
  basic: {
    name:     'Basic',
    price:    9.99,
    label:    '$9.99 / mo',
    features: ['Everything in Free', 'Volume Spike strategy', 'Telegram alerts: Triple Alignment (W+D+4H), Double Alignment, Volume Spike'],
  },
  pro: {
    name:     'Pro',
    price:    19.99,
    label:    '$19.99 / mo',
    features: ['Everything in Basic', 'RBPullback strategy', '20-50 Pullback strategy', 'Telegram alerts: RBPullback, 20-50 Pullback'],
  },
  elite: {
    name:     'Elite',
    price:    39.99,
    label:    '$39.99 / mo',
    features: ['Everything in Pro', 'RSI-MTF', 'CCI Pullback', 'MTF 50 SMA', 'ProjectTD', 'ProjectTD + CCI Combined', 'Trend Pullback', '20 EMA S/R', '20/8 EMA Parabolic', 'Trend Breakout', 'TTM Squeeze', 'MA Crossover', 'KC Extreme', 'Combined (multi-strategy confluence)', 'Telegram alerts: all strategies'],
  },
};
